import $  from 'jquery';

export class SearchForm {
    private $form: JQuery<HTMLElement>;

    constructor(element: HTMLElement) {
        this.$form = $(element);
        this.initEvents();
    }

    private initEvents(): void {
        const categories = this.$form.find('.search-filter [type=checkbox]');
        const sorting = this.$form.find('.sort-row-select select');

        categories.on('change', () => {
            this.$form.trigger('submit');
        });

        sorting.on('change', () => {
            this.$form.trigger('submit');
        });
    }
}
